import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useConsent, saveConsent } from '@/lib/consent';

// Einwilligungsabfrage fuer optionale Google-Dienste. "Nur notwendige" ist gleichwertig
// zu "Alle erlauben" gestaltet (keine Verleitung zur Zustimmung).
const ConsentBanner = () => {
  const { t } = useTranslation();
  const { consent, reopened } = useConsent();

  if (consent && !reopened) return null;

  return (
    <div
      role="dialog"
      aria-label={t('consent.title')}
      className="fixed inset-x-0 bottom-0 z-[100] border-t border-slate-300 bg-white shadow-2xl"
      data-testid="consent-banner"
    >
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col md:flex-row md:items-center gap-4">
        <div className="text-sm text-slate-700 flex-1">
          <p className="font-semibold text-slate-900 mb-1">{t('consent.title')}</p>
          <p>
            {t('consent.text')}{' '}
            <Link to="/bess/datenschutz" className="underline text-blue-700">
              {t('consent.moreInfo')}
            </Link>
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 md:shrink-0">
          <button
            type="button"
            onClick={() => saveConsent({ ads: false, recaptcha: false })}
            className="px-4 py-2 rounded-md border border-slate-400 text-slate-900 text-sm font-medium hover:bg-slate-100"
            data-testid="consent-reject"
          >
            {t('consent.reject')}
          </button>
          <button
            type="button"
            onClick={() => saveConsent({ ads: true, recaptcha: true })}
            className="px-4 py-2 rounded-md border border-slate-400 text-slate-900 text-sm font-medium hover:bg-slate-100"
            data-testid="consent-accept"
          >
            {t('consent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
